import { Button, type ManagedModalComponentProps } from "@shapr3d/frontend-lib";

import useTranslation from "../../../../hooks/useTranslation";
import { Modal } from "../../../../lib/modal";

import style from "./ARNotSupportedModal.module.css";

type ARNotSupportedModalProps = {
  modalProps: ManagedModalComponentProps;
};

export const ARNotSupportedModal = ({ modalProps }: ARNotSupportedModalProps) => {
  const { t, m } = useTranslation();
  return (
    <Modal {...modalProps} size="small" persistent telemetryName="ar_not_supported">
      <div className={style.container}>
        <div className={style.title}>{t(m.ARNotSupportedModal.Title)}</div>
        <div className={style.text}>
          {t(m.ARNotSupportedModal.CannotDisplay)}
          <br />
          {t(m.ARNotSupportedModal.TryDifferentBrowser)}
        </div>
        <Button variant="primary" onClick={modalProps.onClose} className={style.button}>
          {t(m.ARNotSupportedModal.OK)}
        </Button>
      </div>
    </Modal>
  );
};
